module.exports = __webpack_public_path__ + "static/media/image_2.72cb57a3.jpeg";